<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-bootbutton
            title="افزودن اسلاید"
            type="primary"
            icon="fas fa-plus-square"
            btn-width="200px"
            @click.native="toggleModal"
            v-if="$acl.can('create', 'slides')"
          />
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :schema-total="'total'"
            :schema-data="'data'"
          />
        </div>
      </bita-ibox>
    </div>
    <slide-form
      ref="form"
      :title="formTitle"
      :is-loading="isLoadingModal"
      @on-create="(e) => save(e)"
      @on-update="(e) => update(e)"
    />
  </div>
</template>
<script>
import SlideForm from "./components/SlideForm";
import { slideApi } from "@/api/apiManagement";

export default {
  components: { SlideForm },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت اسلایدها", link: "" },
      ],
      isLoadingModal: false,
      isLoadingGrid: false,
      formTitle: "",
      slides: [],
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    gridColumns() {
      let commands = [];
      if (this.$acl.can("edit", "slides"))
        commands.push({
          text: "ویرایش",
          name: "my",
          // template: this.gridButtons.edit,
          click: this.editRow,
        });
      if (this.$acl.can("delete", "slides"))
        commands.push({
          text: "حذف",
          name: "delete",
          // template: this.gridButtons.delete,
          click: this.delete,
        });
      return [
        {
          field: "image",
          title: "عکس",
          template: this.getImage,
          width: "100px",
        },
        { field: "title", title: "نام" },
        { field: "type", title: "نوع", template: this.getType },
        { field: "order", title: "ترتیب" },
        { field: "size", title: "اندازه", template: this.getSize },
        {
          title: "عملیات",
          command: commands,
        },
      ];
    },
  },

  methods: {
    getType(element) {
      let title = "";

      switch (Number(element.type)) {
        case 1:
          title = "اسلایدر";
          break;
        case 2:
          title = "عکس محصول";
          break;
        case 3:
          title = "بنر ساید بار";
          break;
        case 4:
          title = "بنر سرصفحه";
          break;
      }
      return title;
    },
    getSize(element) {
      if (!element) return "";
      if (this.isSlider(element.type)) return "-";
      switch (element.size) {
        case 1:
          return "کوچک";
        case 2:
          return "متوسط";
        case 3:
          return "بزرگ";
        default:
          return "";
      }
    },
    getImage(element) {
      return `
      <img src="${element.image_url}" alt="تصویر"
       class="img rounded-circle circle-border slider-image">
      `;
    },
    isSlider(type) {
      return type == 1;
    },
    save(slide) {
      this.isLoadingModal = true;
      slide = this.getFormData(slide);

      slideApi
        .createSlide(slide)
        .then((res) => {
          this.formSucceeded(res.data.message);
          this.toggleModal();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    formSucceeded(message) {
      this.$izitoast("success", "عملیات موفق", message);
      this.$refs.form.reset();
      this.toggleModal();
      this.loadData();
    },
    update(slide) {
      this.isLoadingModal = true;
      let formData = this.getFormData(slide);

      slideApi
        .updateSlide(slide.id, formData)
        .then((res) => {
          this.formSucceeded(res.data.message);
        })
        .catch((err) => {
          this.$refs.form.setErrors(err.response.data.errors);
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    getFormData(data) {
      let formData = new FormData();
      for (var key in data) {
        if (data[key] != null) formData.append(key, data[key]);
      }
      return formData;
    },
    toggleModal() {
      this.$toggleModal("#slide-form");
    },
    editRow(e) {
      e.preventDefault();
      let slide = this.$refs.grid.getSelectedGridRow(e);
      let editForm = {
        id: slide.id,
        title: slide.title,
        description: slide.description,
        image_url: slide.image_url,
        order: slide.order,
        size: 0,
        link: slide.link,
        type: 0,
      };
      this.formTitle = `ویرایش ${slide.title}`;
      this.toggleModal();
      this.$refs.form.setForm(editForm, slide.type, slide.size);
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    readData(e) {
      this.isLoadingGrid = true;
      // this.$resetGrid();
      slideApi
        .getSlides()
        .then(({ data }) => {
          e.success(data.entity);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    delete(e) {
      e.preventDefault();
      let slide = this.$refs.grid.getSelectedGridRow(e);
      console.log(slide);
      this.$alert("question", `آیا از حذف ${slide.title} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          slideApi
            .deleteSlide(slide.id)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
table td {
  text-align: center;
}
</style>
<style>
img.slider-image {
  border: none;
  border-radius: 50%;
  object-fit: cover;
  height: 50px;
  width: 50px;
}
</style>
